import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { UserService } from './user.service';

export const Ng1UserModule = angular
  .module('control-room.angular.user-service', [])
  .factory('crUserService', downgradeInjectable(UserService));
